import { render, staticRenderFns } from "./intangibleCulturalDetail.vue?vue&type=template&id=17915f58&scoped=true"
import script from "./intangibleCulturalDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./intangibleCulturalDetail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./intangibleCulturalDetail.vue?vue&type=style&index=0&id=17915f58&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17915f58",
  null
  
)

export default component.exports